import { render } from "./RemoveMembersModal.vue?vue&type=template&id=b342d670"
import script from "./RemoveMembersModal.vue?vue&type=script&lang=js"
export * from "./RemoveMembersModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__